import React from 'react';
import { NavLink, useLocation } from "react-router-dom";
import './Settings.css';

const SettingsNavigator = () => {
    const location = useLocation();

    return (
        <div className="settings-navigator">
            <NavLink
                to="/settings/account"
                className={({ isActive }) => (isActive ? "active" : "")}
            >
                <div>Account Settings</div>
            </NavLink>
            {/*<NavLink*/}
            {/*    to="/settings/learning"*/}
            {/*    className={({ isActive }) => (isActive ? "active" : "")}*/}
            {/*>*/}
            {/*    <div>Learning Preferences</div>*/}
            {/*</NavLink>*/}
        </div>
    );
};

export default SettingsNavigator;